<template>
  <div class="upDataIDQr">
    <em class="backQr"></em>
    <div class="upDataIDQrDiv">
        <div class="upDataIDQrTitle">
          <p>登录成功</p>
<!--          <em></em>-->
        </div>
      <div class="QRDiv">
        <div id="qrcode" ref="qrCodeUrl"></div>
      </div>
      <p class="describe">请扫描上方二维码上传身份证</p>
    </div>

  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import {getStore} from "@/utils/localStorage";
import {faceServe} from  '@/api/home'
export default {
  name: "upDataIDQr",
  data() {
    return {
      times: '',
      mobileData: ''
    }
  },
  props:{
    classId: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.mobileData = JSON.parse(getStore('userInfo')).mobile;
    this.creatQrCode();
    this.getData();
  },
  destroyed() {
    clearInterval(this.times);
  },
  methods: {
    getData() {
      this.times =  setInterval(() => {
        faceServe.getStudent({
          tag: this.mobileData
        }).then(data => {
          if(data.result.url) {
            this.$message.success('上传成功');
            // this.$router.replace({ path: "/Template" }); 
            this.$emit('getData')
            clearInterval(this.times);
          }
        })
      }, 3000)
    },
    creatQrCode() {
      const url = window.location.origin;
      const getData = getStore('token');
      const entranceType = getStore('_ENTRANCETYPE');
      const text = `${url}/#/upDataID?token=${getData}&mobile=${this.mobileData}&entranceType=${entranceType}&classId=${this.classId}`;
      //const text = `${url}/dist/#/upDataID?token=${getData}&mobile=${this.mobileData}`;
      console.log(text)
      this.qRCodeData = new QRCode(this.$refs.qrCodeUrl, {
        text: text,
        width: 180,
        height: 180,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.L
      });
      this.qRCodeData._el.title = '';
    },
  }
}
</script>

<style scoped lang="scss">
.upDataIDQr{width: 100%;display: flex;justify-content: center}
.upDataIDQr .upDataIDQrDiv{width: 520px;height: 552px;background-color: #fff;margin-top: 200px;display: flex;flex-direction: column;align-items: center;box-shadow: 0 1px 21px 0 rgba(0, 0, 0, 0.07);}
.upDataIDQr .upDataIDQrDiv .upDataIDQrTitle{width: 120px;position: relative;display: flex;justify-content: center;margin: 50px 0}
.upDataIDQr .upDataIDQrDiv .upDataIDQrTitle p{font-size: 22px;color: #333}
.upDataIDQr .upDataIDQrDiv .upDataIDQrTitle em{width: 120px;height: 13px;background-color: #3056FF;opacity: 0.7;position: absolute;bottom: 0;left: 0;}
.upDataIDQr .upDataIDQrDiv .QRDiv{border-top: 1px solid #c0c0c0;padding-top: 20px;margin-bottom: 30px}
.upDataIDQr .upDataIDQrDiv .describe{font-size: 16px;color: #333}
.upDataIDQr .backQr{width: 100%;height: 354px;background: url("~@/assets/images/upData/upDataQrBack.png") no-repeat;background-size: 100% 100%;position: absolute;top: 520px}




</style>
